import { render, staticRenderFns } from "./LoteProdutoModalPdv.vue?vue&type=template&id=16e45682&scoped=true"
import script from "./LoteProdutoModalPdv.vue?vue&type=script&lang=js"
export * from "./LoteProdutoModalPdv.vue?vue&type=script&lang=js"
import style0 from "./LoteProdutoModalPdv.vue?vue&type=style&index=0&id=16e45682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e45682",
  null
  
)

export default component.exports